//Urls servicios externos 
export const urlJuntas = "https://wsdeoe2024-pru.ine.mx/ws-sesionesConsejo"; //url para consultar las Juntas Ejecutivas
export const urlCuestionarios = "https://pru-cuestionarios-inst.ine.mx/cuestionarios/api/consultaCalificacion"; //url para consultar la calificación de cuestionarios
//export const urlCuestionarios = "https://seg-cuestionarios-inst.ine.mx/cuestionarios/api/consultaCalificacion"; //url para consultar la calificación de cuestionarios
//export const urlCuestionarios = "https://capa-cuestionarios-inst.ine.mx/cuestionarios/api/consultaCalificacion"; //url para consultar la calificación de cuestionarios
//export const urlCuestionarios = "https://cuestionarios-inst.ine.mx/cuestionarios/api/consultaCalificacion"; //url para consultar la calificación de cuestionarios

//Urls para el ambiente de desarrollo
/*export const basePath = "https://localhost:8443/centralObservadores/ws";//url del servidor//
export const urlHome = "http://localhost:3000/" //url inicio;
export const URL_IMAGEN="https://localhost:8443/centralObservadores/ws/solicitud/imagen";
export const URL_ORGANIZACION = 1;*/

//Urls para el ambiente de pruebas EXT PJ 2025
/*export const basePath = "https://pru-pjf2025-observadores.ine.mx/centralObservadores/ws" // url del servidor de pruebas
export const urlHome = "https://pru-pjf2025-observadoresweb-deoe.ine.mx/" //url inicio pruebas;
export const URL_IMAGEN="https://pru-pjf2025-observadores.ine.mx/centralObservadores/ws/solicitud/imagen";
export const URL_ORGANIZACION = 2;*/

//Urls para el ambiente de capacitación EXT PJ 2025
/*export const basePath = "https://capa-pjf2025-observadores.ine.mx/centralObservadores/ws" // url del servidor de pruebas
export const urlHome = "https://capa-pjf2025-observadoresweb-deoe.ine.mx/" //url inicio pruebas;
export const URL_IMAGEN="https://capa-pjf2025-observadores.ine.mx/centralObservadores/ws/solicitud/imagen";
export const URL_ORGANIZACION = 2;*/

//Urls para el ambiente de seguridad EXT PJ 2025
/*export const basePath = "https://seg-pjf2025-observadores.ine.mx/centralObservadores/ws" // url del servidor de pruebas
export const urlHome = "https://seg-pjf2025-observadoresweb-deoe.ine.mx/" //url inicio pruebas;
export const URL_IMAGEN="https://seg-pjf2025-observadores.ine.mx/centralObservadores/ws/solicitud/imagen";
export const URL_ORGANIZACION = 2;*/

//Urls para el ambiente de producción EXT PJ 2025
export const basePath = "https://pj2025-observadoresapp.ine.mx/centralObservadores/ws" // url del servidor de pruebas
export const urlHome = "https://pjf2025-observadores.ine.mx/" //url inicio pruebas;
export const URL_IMAGEN="https://pj2025-observadoresapp.ine.mx/centralObservadores/ws/solicitud/imagen";
export const URL_ORGANIZACION = 2;


//Constantes para cifrado de contraseña
export const VECTOR_INICIO = "gqLOHUioQ0QjhuvI";
export const LLAVE_CIFRADO = "inC2H19lkVbAPfakxcrtTREdd0FloLyw";